import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css'
import Link from '../../common/Link'
import BlurImg from '../../common/BlurImg'
import { trackEventLog } from '../../../core/utils'
import defaultImg from './default.png'

class RecommendCard extends React.Component {

  static propTypes = {
    data: PropTypes.object.isRequired,
    inx: PropTypes.number.isRequired,
    inLoc: PropTypes.string.isRequired,
  }

  render() {
    const { data, inx, inLoc } = this.props
    return (
      <div className={s.root}>
        <Link
          onClick={() => { trackEventLog(`w/index/explore/${inx}`) }}
          to={data.url}
          extraParams={{ inLoc }}
        >
          <BlurImg
            addStyle={s.img}
            placeHolder={defaultImg}
            originSrc={data.image}
            altText={data.title}
          />
          <h4 className={s.title}>{data.title}</h4>
        </Link>
      </div>
    );
  }
}

export default withStyles(s)(RecommendCard);



// WEBPACK FOOTER //
// ./src/components/common/RecommendCard/index.js